import { SETDONORINFO } from '../../actions/donorList';


export const DonorStateReducer = (prevState = {
    donorInfo: []
}, action) => {
    let newState = {...prevState}
    switch (action.type) {
        case SETDONORINFO:
            return newState
        default:
            return prevState
    }
}
